module.exports = __webpack_public_path__ + "img/publish-fail-icon.df0dd64f.png";